<script setup lang="ts">
import { computed, provide, ref } from 'vue';

const props = defineProps<{
  modelValue?: string | number;
  disabled?: boolean;
  name?: string;
  direction?: 'vertical' | 'horizontal';
  size?: 'small' | 'medium' | 'large';
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string | number];
}>();

const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

function selectOption(value: string | number) {
  if (props.disabled) return;
  selectedValue.value = value;
}

const groupClasses = computed(() => [
  'radio-group',
  `radio-group--${props.direction || 'vertical'}`,
  `radio-group--${props.size || 'medium'}`
]);

// Предоставляем контекст группы для дочерних RadioBox
provide('radioGroup', {
  selectedValue,
  selectOption,
  disabled: computed(() => props.disabled),
  name: computed(() => props.name)
});
</script>

<template>
  <div :class="groupClasses" :role="'radiogroup'" :aria-label="name">
    <slot></slot>
  </div>
</template>

<style scoped>
.radio-group {
  display: flex;
  /* gap: 16px; */
}

.radio-group--vertical {
  flex-direction: column;
  /* gap: 12px; */
}

.radio-group--horizontal {
  flex-direction: row;
  /* gap: 24px; */
}

.radio-group--small {
  /* gap: 8px; */
}

.radio-group--small.radio-group--vertical {
  /* gap: 8px; */
}

.radio-group--small.radio-group--horizontal {
  /* gap: 16px; */
}

.radio-group--large {
  /* gap: 20px; */
}

.radio-group--large.radio-group--vertical {
  /* gap: 16px; */
}

.radio-group--large.radio-group--horizontal {
  /* gap: 32px; */
}
</style>
